import React from "react";
import { CheckIcon, GlobeIcon, LockIcon } from "lucide-react";
import { CTAButton } from "./CTAButton";
import { Countdown } from "./Countdown";
import { ScarcityBar } from "./ScarcityBar";
import { MOCKUP_URL } from "../data/offer";
import { offerIncludes, valueStack } from "../data/content";
export function OfferStack() {
  const total = valueStack.reduce((sum, v) => sum + v.value, 0);
  return <section id="offer" className="bg-brand-50 px-4 py-16 md:px-8 md:py-24" data-id="element-208" data-mp="1x5ps0ux9t5iv">
      <div className="mx-auto max-w-3xl" data-id="element-209" data-mp="1t55v9sgm03x9">
        <h2 className="text-center text-3xl font-extrabold leading-tight tracking-tight text-brand-900 md:text-[2.6rem]" data-id="element-210" data-mp="1t678o3l3l2i5">
          Your complete perimenopause clinical toolkit
        </h2>
        <p className="mt-3 text-center text-lg text-muted" data-id="element-211" data-mp="224j2eeh9gget">Everything in one digital collection</p>

        <div className="mt-10 overflow-hidden rounded-3xl bg-white shadow-2xl shadow-brand-900/15 ring-4 ring-gold-400" data-id="element-212" data-mp="1eeotg802bbzu">
          <div className="bg-brand-900 px-6 py-4 text-center text-sm font-extrabold uppercase tracking-wide text-gold-300" data-id="element-213" data-mp="19gmz2qx6rq92">
            Special digital offer
          </div>
          <div className="p-5 sm:p-8 md:p-10" data-id="element-214" data-mp="19n4xgm4q9uy3">
            <img src={MOCKUP_URL} alt="The complete toolkit" className="mx-auto w-full max-w-md" data-id="element-215" data-mp="19lts4hvmwf4v" />

            <table className="mt-8 w-full text-left" data-id="element-216" data-mp="1eh95l8pqc90r">
              <thead data-id="element-217" data-mp="1jcofjpkm9krw">
                <tr className="border-b-2 border-brand-100 text-xs font-bold uppercase tracking-wide text-muted" data-id="element-218" data-mp="1jd6mbg4wnhe2">
                  <th className="pb-3 pr-3" scope="col" data-id="element-219" data-mp="lskbvur075z1">Your clinical resources</th>
                  <th className="pb-3 text-right" scope="col" data-id="element-220" data-mp="qpke1ukqfokv">Value</th>
                </tr>
              </thead>
              <tbody data-id="element-221" data-mp="vqrpc3m335wa">
                {valueStack.map(v => <tr key={v.item} className="border-b border-brand-100" data-id="element-222" data-mp="zrjyyxyvbct3">
                    <td className="py-3.5 pr-3 text-[15px] font-semibold leading-snug text-ink" data-id="element-223" data-mp="274bxhhzwhli1">{v.item}</td>
                    <td className="py-3.5 text-right text-[15px] font-bold text-muted" data-id="element-224" data-mp="2b44codjsupwd">${v.value}</td>
                  </tr>)}
              </tbody>
              <tfoot data-id="element-225" data-mp="71kur7pihmvx">
                <tr data-id="element-226" data-mp="723ztnu2cgsj">
                  <td className="pt-4 text-sm font-extrabold uppercase text-ink" data-id="element-227" data-mp="70j6u2ned5ws">Total comparison value</td>
                  <td className="pt-4 text-right text-lg font-extrabold text-red-600 line-through" data-id="element-228" data-mp="l0k99mjb8led">${total}</td>
                </tr>
              </tfoot>
            </table>

            <div className="mt-8 rounded-2xl bg-brand-50 p-6 text-center" data-id="element-229" data-mp="3oiuaqz94dg2f">
              <p className="text-base font-bold text-ink" data-id="element-230" data-mp="3kgh66e63zo78">Today, get everything for just…</p>
              <p className="mt-1 text-2xl font-bold text-muted line-through" data-id="element-231" data-mp="21y5fzwesg6r">${total}</p>
              <p className="text-7xl font-extrabold tracking-tight text-brand-800 md:text-8xl" data-id="element-232" data-mp="3tgvtfj2mvddd">
                $27<span className="ml-1 align-top text-2xl font-bold md:text-3xl" data-id="element-233" data-mp="35rb9oxynoc31">USD</span>
              </p>
              <p className="mt-2 text-sm font-extrabold uppercase tracking-wide text-brand-700" data-id="element-234" data-mp="30shtuyvwc8zp">One-time payment</p>
              <p className="mt-1 text-sm text-muted" data-id="element-235" data-mp="1g9nrzncxfqix">No monthly subscription. No recurring charges.</p>
              <p className="mx-auto mt-4 flex max-w-sm items-center justify-center gap-2 rounded-xl bg-white px-4 py-2.5 text-sm font-semibold text-ink" data-id="element-236" data-mp="1l15u4eqorx5h">
                <GlobeIcon className="h-4 w-4 shrink-0 text-brand-600" aria-hidden="true" data-id="element-237" data-mp="177eld8ks4hat" />
                Automatic currency conversion to your local currency
              </p>
            </div>

            <ul className="mt-6 grid gap-2.5 sm:grid-cols-2" data-id="element-238" data-mp="1zw27t7h9lcpy">
              {offerIncludes.map(t => <li key={t} className="flex items-center gap-2 text-base font-semibold text-ink" data-id="element-239" data-mp="23xfh5rjkfy1m">
                  <CheckIcon className="h-5 w-5 shrink-0 text-emerald-600" strokeWidth={3} aria-hidden="true" data-id="element-240" data-mp="1q2d14bl08sb3" />
                  {t}
                </li>)}
            </ul>

            <div className="mt-8" data-id="element-241" data-mp="emws7ffm14n2">
              <ScarcityBar data-id="element-242" data-mp="jjn9u772c8al" />
            </div>

            <div className="mt-6" data-id="element-243" data-mp="jlhrncn1fkag">
              <CTAButton label="Yes! I want the complete clinical toolkit for $27" pulse className="md:w-full" data-id="element-244" data-mp="ytju5byksnzn" />
            </div>
            <p className="mt-4 flex items-center justify-center gap-1.5 text-xs font-medium text-muted" data-id="element-245" data-mp="u2lbi5q47dt8">
              <LockIcon className="h-3.5 w-3.5" aria-hidden="true" data-id="element-246" data-mp="q2b7uzpsozhj" />
              Secure checkout · Instant access
            </p>

            <div className="mt-8 border-t border-brand-100 pt-7" data-id="element-247" data-mp="l3zyeq3ewqzu">
              <Countdown data-id="element-248" data-mp="1hrec4fhom9u6" />
            </div>
          </div>
        </div>

        <p className="mt-6 text-center text-xs leading-relaxed text-muted" data-id="element-249" data-mp="1dr3web438524">
          The comparison values above are offer-assigned values for the included digital resources, not
          independently verified retail prices.
        </p>
      </div>
    </section>;
}